// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_kn-0";
export var buttonContainer = "_kn-3";
export var cancelButton = "_kn-4";
export var headerSection = "_kn-6";
export var headerTitle = "_kn-9";
export var messageSideLeft = "_kn-1";
export var messageSideRight = "_kn-2";
export var orderNumberContainer = "_kn-7";
export var orderNumberLabel = "_kn-8";
export var submitButton = "_kn-5";